export default __webpack_public_path__ + "static/media/filling_7.a6a80100.webp";